let uniAjaxLoader = '//cdn.shopify.com/s/files/1/2617/5104/t/15/assets/ajax-loader.gif?v=4135686330247201572';
let uniUrlApi = 'https://api.mmocare.com/';
let uniPreviewUrl = uniUrlApi + 'arts/preview/';

jQuery(document).ready(function() {
  	var uniqueFileId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  	jQuery('#spUniqueFile').val(uniqueFileId);

  	jQuery(document).on('click', '#uniPreviewDesign', function() {
    	var $thisButton = jQuery(this);
    	//preview($thisButton);
        uniPreview($thisButton);

    	return false;
  	});
  
//   	jQuery(document).on('click', '#BuyItNowTrigger', function() {
//       	jQuery('#AddToCart.bold_clone').trigger('click');
//   		jQuery('#preview_popup').modal('hide');

//       	return false;
//   	});
  
  	var fileNameArray = [];
  	jQuery('.cart__row-preview').each(function(index, element){
      var fileName = jQuery(this).data('file');
      if (fileNameArray.includes(fileName)) {
        jQuery(this).data('file', '').attr('data-file', '');
      } else if (fileName != '') {
        fileNameArray.push(fileName);
      }
      
      preview2(jQuery(this), index);
  	});
});

function uniAddSpinner(ele, position) {
  	if (ele == '' || ele === undefined) {
    	return;
  	}
  
  	uniRemoveSpinner(ele, position);

    if (position === undefined) {
        position = 'inner';
    }

    if (position == 'inner') {
        ele.append(' <i class="fa fa-spinner fa-spin"></i>');
    } else if (position == 'after') {
        ele.after('<i class="fa fa-spinner fa-spin"></i>');
    }
}

function uniRemoveSpinner(ele, position) {
  	if (ele == '' || ele === undefined) {
    	return;
  	}
  
    if (position === undefined) {
        position = 'inner';
    }

    if (position == 'inner') {
        ele.find('.fa-spin').remove();
    } else if (position == 'after') {
        ele.next().remove();
    }
}

function preview(button) {
  //open popup preview
  jQuery('#preview_content').html('<i class="fa fa-spinner fa-spin"></i> The preview is being processed. Please wait for a moment!');
  jQuery('#preview_popup').modal('show');

  jQuery.ajax({
    type: 'GET',
    url: uniUrlApi + 'preview?key=2nALZE__ivDawAx7hL-wjtccQosHSL&url='+productHandle+'&v='+productVendor+'&file=' + jQuery('#spUniqueFile').val(),
    data: jQuery('#AddToCartForm').serialize(),
    success: function (data) {
      if (data.success) {
        jQuery('#spUniqueFile').val(data.file);
 
        //open popup preview
        jQuery('#preview_content').html('<img src="' + data.banner + '" class="img-responsive" /><span style="color:red">If the display of previewing is not good, our designers will fix it manually <br>after ordering for the best result!</span>');
      } else {
        jQuery('#preview_popup').modal('hide');
        Swal.fire({
          title: '', 
          html: data.message,  
          icon: 'error'
        });
      }
    },
    error: function (data) {
      console.log(data);
      jQuery('#preview_popup').modal('hide');
      Swal.fire({
        title: '', 
        html: 'Oops, something wrong',  
        icon: 'error'
      });
    },
    ajaxError: function (data) {
      jQuery('#preview_popup').modal('hide');
      Swal.fire({
        title: '', 
        html: 'Oops, something wrong',  
        icon: 'error'
      });
    }
  });
}

function preview2(ele, index) {
  var filename = jQuery(ele).data('file');
  var dataUrl = jQuery(ele).data('url');
  var dataVendor = jQuery(ele).data('vendor');
  var dataVariant = jQuery(ele).data('variant');
  var dataJson = jQuery(ele).data('property');
  var dataProperty = uniCalculateData(dataVariant, dataJson);

  var eleBannerUrl = jQuery(ele).find('.card__img img').attr('src');
  let imageNotExist = checkImageExists(eleBannerUrl);

  if (imageNotExist) {
    console.log(eleBannerUrl + ' not exists');
    index++;
    uniShowLoadingState('cart__image'+index);
    jQuery.ajax({
      type: 'GET',
      url: uniUrlApi + 'preview?key=2nALZE__ivDawAx7hL-wjtccQosHSL&url='+dataUrl+'&v='+dataVendor+'&file=' +filename,
      data: dataProperty,
      success: function (data) {
        if (data.success) {
		  jQuery(ele).find('.card__img img').attr('src', data.banner);
          setTimeout(function(){ 
            uniRemoveLoadingState('cart__image'+index);
          }, 1000);

          var uniqueFileTmp = {};
          uniqueFileTmp['spuniquefile'] = data.file;
          dataProperty['properties'] = uniqueFileTmp;
          dataProperty['img_url'] = uniPreviewUrl + data.file + '.jpg';
          dataProperty['id'] = jQuery(ele).data('id');

          if (Array.isArray(dataProperty) && dataProperty.length > 0) {
            //update cart
//             jQuery.ajax({
//               url: '/cart/change.js',
//               type: 'post',
//               dataType: 'json',
//               data: dataProperty, 
//               success: function(cart){ 
//                 /* Yay!  The cart updated! */ 
//               }
//             });
          }
        } else {
          console.log(data) ;
        }
      },
      error: function (data) {
        console.log(data);
      },
      ajaxError: function (data) {
        console.log(data);
      }
    });
  }
}

function uniPreview(button) {
  //collect form data
  let formData = $('#product_form_' + meta.product.id).serializeArray();
  jQuery('form .swatches__holder span.swatch--active').each(function(index, ele) {
      formData.push({name: 'option-' + index, value: jQuery(this).html()});
  });

  //open popup preview
  Swal.fire({
    title: 'Preview Your Personalization',
    html: 'The preview is being processed. Please wait for a moment!',
    allowOutsideClick: false,
  	confirmButtonText: 'Buy It Now',
    confirmButtonColor: '#08aa00',
    cancelButtonText: 'Close',
    didOpen: () => {
      Swal.showLoading();

      jQuery.ajax({
        type: 'GET',
        url: uniUrlApi + 'preview?key=2nALZE__ivDawAx7hL-wjtccQosHSL&url='+productHandle+'&v='+productVendor+'&file=' + jQuery('#spUniqueFile').val(),
        data: jQuery.param(formData),
        success: function (data) {
          if (data.success) {
            jQuery('#spUniqueFile').val(data.file);
    		Swal.hideLoading();
			Swal.update({showCancelButton: true});

            let resultHtml = '<img src="' + data.banner + '" class="img-responsive" /><span style="color:red">If the display of previewing is not good, our designers will fix it manually <br>after ordering for the best result!</span>';
			jQuery('.swal2-html-container').html(resultHtml);

          } else {
            Swal.fire({
              title: '', 
              html: data.message,  
              icon: 'error'
            });
          }
        },
        error: function (data) {
          console.log(data);
          Swal.fire({
            title: '', 
            html: 'Oops, something wrong',  
            icon: 'error'
          });
        },
        ajaxError: function (data) {
          Swal.fire({
            title: '', 
            html: 'Oops, something wrong',  
            icon: 'error'
          });
        }
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      jQuery('#AddToCart.bold_clone').trigger('click');
    }
  });
}

function uniShowLoadingState(elementId) {
  if (elementId === undefined) {
    elementId = 'document';
    var coordinate = {top:0, left: 0};
    var loadingWidth = jQuery(window).width() - 2;
    var loadingHeight = jQuery(window).height() - 2;

  } else {
    var coordinate = jQuery('#' + elementId).offset();
    var loadingWidth = jQuery('#' + elementId).width() - 2;
    var loadingHeight = jQuery('#' + elementId).height() - 2;
  }

  if (loadingWidth == -2) {
    loadingWidth = 350;
  }

  if (loadingHeight == -2) {
    loadingHeight = 32;
  }

  var div = jQuery(document.createElement('div'));

  div.attr('id', elementId + '-loading');
  div.attr('class', 'uni-loading');
  div.css({width: loadingWidth,
           height: loadingHeight,
           position: elementId == 'document' ? 'fixed' : 'absolute',
           zIndex: elementId == 'document' ? '2' : '2000',
           top: coordinate.top + 1,
           left: coordinate.left + 1
          });

  var loadingMargin = Math.round((loadingHeight / 2) - 16);
  var content = '<div style="text-align:center;margin-top:' + loadingMargin + 'px"><img src="'+uniAjaxLoader+'" /></div>';

  div.html(content);
  div.appendTo('body');
}

function uniRemoveLoadingState(elementId) {
  if (elementId === undefined) {
    elementId = '#document';
  } else {
    elementId = '#' + elementId;
  }

  jQuery(elementId + '-loading').remove();
}

function uniCalculateData(variant, string) {
	var dataProperty = new FormData();
  	var stringArray = string.split('||');

  	for (i = 0; i < stringArray.length - 1; i = i+2) {
        dataProperty.append('properties['+stringArray[i]+']', stringArray[i+1]);
    }
  
  	var returnObject = {};
  	returnObject['option-0'] = variant;
	dataProperty.forEach(function(value, key){
    	returnObject[key] = value;
	});

    return returnObject;
}

function checkImageExists(image_url) {
    var http = new XMLHttpRequest();

    http.open('GET', image_url, false);
    http.send();

    return http.status != 200;
}